// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"92876b8c","189":"58208e8f","453":"9686779e","733":"42f216a8","833":"7e8644c0"}[chunkId] + ".chunk.js";
};